import React from 'react';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import CommonBalanceReceipt from './common-includes/CommonBalanceReceipt';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';


function PosBalanceReceipt(props) {
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};
	const title = props.posBalanceData.object.tsbo? getLabel('retail.pos_balance_by_operator') : getLabel('retail.pos_balance');
	return (
		<body style={additionalStyle}>
			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={title}></ShopReceiptHeader>
			
			<CommonBalanceReceipt showFromToDate={true} 
								  showTerminalBalance={false}
								  showPvend={true}
								  showMov={true}
								  showTotOperations={true}
								  showEffectiveAmount={false}
								  showTotalWithoutSign={true}
								  detailedBalanceData={props.posBalanceData}>
			
			</CommonBalanceReceipt>
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default PosBalanceReceipt;